import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onBeforeMount, ref } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { useFullscreen } from '@vueuse/core'
    import Api from '@/services/api'
    import CreateCategory from '@/components/modals/creates/CreateCategory.vue'
    import CreateUser from '@/components/modals/creates/CreateUser.vue';
    import CreateProduct from '@/components/modals/creates/CreateProduct.vue'
    import CreatePlace from '@/components/modals/creates/CreatePlace.vue'
    import CreateProp from '@/components/modals/creates/CreateProp.vue'
    import ModalComponent from '@/components/modals/ModalComponent.vue'
    import CreateEvent from '@/components/modals/creates/CreateEvent.vue';
    import CreateCompany from '@/components/modals/creates/CreateCompany.vue';
    import { ElButton, ElIcon } from 'element-plus';
    import { Avatar, CirclePlusFilled, Message, MessageBox, View } from '@element-plus/icons-vue';
    import CreateVideo from '@/components/modals/creates/CreateVideo.vue';
import CreateAdBanner from '@/components/modals/creates/CreateAdBanner.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const isMaster = ref<boolean>(false)

    const openModal = computed(() => store.getters.openModal)

    const isSidebarOpen = ref(false);
    const activeMenu = ref<string>(store.getters.route)

    const modalTitles = ref<Array<string>>([
        'Criar categoria de produtos',
        'Cadastrar novo entregador/Administrador',
        'Adicionar produto',
        'Cadastrar Local de propaganda',
        'Adicionar propriedade',
        'Publicar evento',
        'Nova Transportadora',
        'Novo vídeo',
        'Novo Banner publicitario'
    ])

    const updateMenu = () => {
        const item = sessionStorage.getItem("user")
        console.log(item)
        const user = item ? JSON.parse(item):{}
        
        isMaster.value = user.role == 'master'
    }

    router.beforeEach(route => {
        activeMenu.value = route.path
        updateMenu()
    })
    
    onBeforeMount(() => updateMenu())
    // onBeforeUpdate(() => updateMenu())

    const toggleSidebar = () => {
        isSidebarOpen.value = !isSidebarOpen.value;
    };

    // const handleLogout = () => {
    //     store.dispatch('logout').then(() => {
    //         router.push({ name: 'Login' });
    //     });
    // };

    const back = () => {
        router.back()
    }

    const { isFullscreen, toggle: toggleFullscreen } = useFullscreen();
    
    const logout = async () => {
        sessionStorage.removeItem("user")
        Api.post("/auth/logout", {})
        store.dispatch('logout')
        router.push("/")
    }

    const showModal = (n: number) => {
        store.commit('setOpenModal', n)
        console.log(n)
    }
    const hideModal = () => {store.commit('setOpenModal', -1)}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Rank = _resolveComponent("Rank")!
  const _component_FullScreen = _resolveComponent("FullScreen")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_User = _resolveComponent("User")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_ShoppingCartFull = _resolveComponent("ShoppingCartFull")!
  const _component_WarnTriangleFilled = _resolveComponent("WarnTriangleFilled")!
  const _component_Star = _resolveComponent("Star")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_Present = _resolveComponent("Present")!
  const _component_Collection = _resolveComponent("Collection")!
  const _component_VideoCamera = _resolveComponent("VideoCamera")!
  const _component_shop = _resolveComponent("shop")!
  const _component_MapLocation = _resolveComponent("MapLocation")!
  const _component_LocationFilled = _resolveComponent("LocationFilled")!
  const _component_AddLocation = _resolveComponent("AddLocation")!
  const _component_Coin = _resolveComponent("Coin")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_Promotion = _resolveComponent("Promotion")!
  const _component_Van = _resolveComponent("Van")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_Back = _resolveComponent("Back")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "app-layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        class: "app-header p-0",
        height: "1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, {
            justify: "space-between",
            align: "middle",
            class: "p-2 col-12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { class: "col-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), {
                    icon: "Menu",
                    onClick: toggleSidebar,
                    class: "menu-toggle-button"
                  }),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "app-title" }, "DashBoard Beasy app", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                align: "middle",
                gutter: 15
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { class: "d-none d-sm-inline col-auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: "Modo tela cheia",
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), {
                            role: "button",
                            onClick: _unref(toggleFullscreen)
                          }, {
                            default: _withCtx(() => [
                              (_unref(isFullscreen))
                                ? (_openBlock(), _createBlock(_component_Rank, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_FullScreen, { key: 1 }))
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { class: "col-auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: "Terminar sesssao",
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), {
                            shape: "circle",
                            role: "button",
                            onClick: logout
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SwitchButton)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, { class: "app-sidebar col-auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                collapse: !isSidebarOpen.value,
                "default-active": activeMenu.value,
                "active-text-color": "#ffd04b",
                "background-color": "#545c64",
                class: "el-menu-vertical-demo",
                router: "",
                "unique-opened": "",
                "text-color": "#fff"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    index: "/profile",
                    title: "Perfil"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_User)
                        ]),
                        _: 1
                      }),
                      _cache[9] || (_cache[9] = _createElementVNode("span", null, "Perfil", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Clubes",
                    index: "1"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ShoppingCartFull)
                        ]),
                        _: 1
                      }),
                      _cache[10] || (_cache[10] = _createElementVNode("span", null, "Pedidos", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/dashboard",
                        title: "Pedidos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_WarnTriangleFilled)
                            ]),
                            _: 1
                          }),
                          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Pedidos pendentes", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/requests",
                        title: "Clubes"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Star)
                            ]),
                            _: 1
                          }),
                          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Pedidos atendidos", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Productos",
                    index: "2"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Present)
                        ]),
                        _: 1
                      }),
                      _cache[13] || (_cache[13] = _createElementVNode("span", null, "Produtos", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/products",
                        title: "Productos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(View))
                            ]),
                            _: 1
                          }),
                          _cache[14] || (_cache[14] = _createElementVNode("span", null, "Listar produtos", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[0] || (_cache[0] = () => {showModal(2)}),
                        index: "#1",
                        title: "Novo producto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CirclePlusFilled))
                            ]),
                            _: 1
                          }),
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "Adicionar novo", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Categorias",
                    index: "3"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Collection)
                        ]),
                        _: 1
                      }),
                      _cache[16] || (_cache[16] = _createElementVNode("span", null, "Categorias", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/categories",
                        title: "Categorias"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(View))
                            ]),
                            _: 1
                          }),
                          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Listar categorias", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        title: "Nova categoria",
                        index: "#2",
                        onClick: _cache[1] || (_cache[1] = () => {showModal(0)})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CirclePlusFilled))
                            ]),
                            _: 1
                          }),
                          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Adicionar nova", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Vídeos",
                    index: "4"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_VideoCamera)
                        ]),
                        _: 1
                      }),
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, "Vídeos promocionais", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/videos",
                        title: "Vídeos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(View))
                            ]),
                            _: 1
                          }),
                          _cache[20] || (_cache[20] = _createElementVNode("span", null, "Listar videos", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[2] || (_cache[2] = () => {showModal(7)}),
                        title: "Novo Vídeos",
                        index: "#3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CirclePlusFilled))
                            ]),
                            _: 1
                          }),
                          _cache[21] || (_cache[21] = _createElementVNode("span", null, "Adicionar novo", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "/stores",
                    title: "Store"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_shop)
                        ]),
                        _: 1
                      }),
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, "Lojas", -1))
                    ]),
                    _: 1
                  }),
                  (isMaster.value)
                    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                        key: 0,
                        title: "usuarios",
                        index: "5"
                      }, {
                        title: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Avatar))
                            ]),
                            _: 1
                          }),
                          _cache[23] || (_cache[23] = _createElementVNode("span", null, "Admins e vendedores", -1))
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, {
                            index: "/users",
                            title: "Admins e vendedores"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElIcon), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(View))
                                ]),
                                _: 1
                              }),
                              _cache[24] || (_cache[24] = _createElementVNode("span", null, "Ver admins e vendedores", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, {
                            onClick: _cache[3] || (_cache[3] = () => {showModal(1)}),
                            title: "Novo Admin ou Vendedor",
                            index: "#4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElIcon), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CirclePlusFilled))
                                ]),
                                _: 1
                              }),
                              _cache[25] || (_cache[25] = _createElementVNode("span", null, "Novo admin ou Vendedor", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_sub_menu, {
                    title: "Lugares",
                    index: "6"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_MapLocation)
                        ]),
                        _: 1
                      }),
                      _cache[26] || (_cache[26] = _createElementVNode("span", null, "Locais Físicos", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/places",
                        title: "Locais"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_LocationFilled)
                            ]),
                            _: 1
                          }),
                          _cache[27] || (_cache[27] = _createElementVNode("span", null, "Listar lugares", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[4] || (_cache[4] = () => {showModal(3)}),
                        title: "Novo Local",
                        index: "#5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_AddLocation)
                            ]),
                            _: 1
                          }),
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "Adicionar novo", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Afiliados",
                    index: "9"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_User)
                        ]),
                        _: 1
                      }),
                      _cache[29] || (_cache[29] = _createElementVNode("span", null, "Afiliados", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/affiliates",
                        title: "Locais"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(View))
                            ]),
                            _: 1
                          }),
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Listar afiliados", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        title: "Pedidos de levantamento",
                        index: "/withdraws"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Coin)
                            ]),
                            _: 1
                          }),
                          _cache[31] || (_cache[31] = _createElementVNode("span", null, "Pedidos de levantamento", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Eventos",
                    index: "7"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Calendar)
                        ]),
                        _: 1
                      }),
                      _cache[32] || (_cache[32] = _createElementVNode("span", null, "Eventos", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/events",
                        title: "Listar eventos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(View))
                            ]),
                            _: 1
                          }),
                          _cache[33] || (_cache[33] = _createElementVNode("span", null, "Listar eventos", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[5] || (_cache[5] = () => {showModal(5)}),
                        title: "Novo evento",
                        index: "#"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }),
                          _cache[34] || (_cache[34] = _createElementVNode("span", null, "Publicar novo", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Transportadoras",
                    index: "8"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_OfficeBuilding)
                        ]),
                        _: 1
                      }),
                      _cache[35] || (_cache[35] = _createElementVNode("span", null, "Empresas de Transporte", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/companies",
                        title: "Empresas de transporte"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(View))
                            ]),
                            _: 1
                          }),
                          _cache[36] || (_cache[36] = _createElementVNode("span", null, "Empresas de Transporte", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[6] || (_cache[6] = () => {showModal(6)}),
                        title: "Nova empresa de transporte",
                        index: "#6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }),
                          _cache[37] || (_cache[37] = _createElementVNode("span", null, "Adicionar novo", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, {
                    title: "Publicidade",
                    index: "10"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Promotion)
                        ]),
                        _: 1
                      }),
                      _cache[38] || (_cache[38] = _createElementVNode("span", null, "Banners de Publicidade", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/ad-banners",
                        title: "Banners publicitarios"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(View))
                            ]),
                            _: 1
                          }),
                          _cache[39] || (_cache[39] = _createElementVNode("span", null, "Banners publicitarios", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[7] || (_cache[7] = () => {showModal(8)}),
                        title: "Nova Publicidade",
                        index: "#10"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }),
                          _cache[40] || (_cache[40] = _createElementVNode("span", null, "Adicionar novo", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "/travel",
                    title: "Viagens"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Van)
                        ]),
                        _: 1
                      }),
                      _cache[41] || (_cache[41] = _createElementVNode("span", null, "Listar viagens Marcadas", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "/message",
                    title: "Mensagem"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Message))
                        ]),
                        _: 1
                      }),
                      _cache[42] || (_cache[42] = _createElementVNode("span", null, "Enviar mensagem", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "/reports",
                    title: "Relatorios"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Coin)
                        ]),
                        _: 1
                      }),
                      _cache[43] || (_cache[43] = _createElementVNode("span", null, "Relatórios financeiros", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["collapse", "default-active"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, { class: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(ElButton), {
        circle: "",
        class: "back-button",
        plain: "",
        type: "primary",
        size: "large",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElIcon), null, {
            default: _withCtx(() => [
              _createVNode(_component_Back)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (modalTitles.value[openModal.value])
        ? (_openBlock(), _createBlock(ModalComponent, {
            key: 0,
            header: modalTitles.value[openModal.value],
            footer: "",
            cardclass: "col-12 col-md-8 col-lg-6",
            onClose: hideModal
          }, {
            default: _withCtx(() => [
              (openModal.value == 0)
                ? (_openBlock(), _createBlock(CreateCategory, { key: 0 }))
                : _createCommentVNode("", true),
              (openModal.value == 1 && isMaster.value)
                ? (_openBlock(), _createBlock(CreateUser, { key: 1 }))
                : _createCommentVNode("", true),
              (openModal.value == 2)
                ? (_openBlock(), _createBlock(CreateProduct, { key: 2 }))
                : _createCommentVNode("", true),
              (openModal.value == 3)
                ? (_openBlock(), _createBlock(CreatePlace, { key: 3 }))
                : _createCommentVNode("", true),
              (openModal.value == 4)
                ? (_openBlock(), _createBlock(CreateProp, { key: 4 }))
                : _createCommentVNode("", true),
              (openModal.value == 5)
                ? (_openBlock(), _createBlock(CreateEvent, { key: 5 }))
                : _createCommentVNode("", true),
              (openModal.value == 6)
                ? (_openBlock(), _createBlock(CreateCompany, { key: 6 }))
                : _createCommentVNode("", true),
              (openModal.value == 7)
                ? (_openBlock(), _createBlock(CreateVideo, { key: 7 }))
                : _createCommentVNode("", true),
              (openModal.value == 8)
                ? (_openBlock(), _createBlock(CreateAdBanner, { key: 8 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})